<template>
  <div class="linkCoupon scroll-touch">
    <div class="linkCoupon-top">
      <div
          :class="userStatus === '未登录' ? 'noLogin' : ''"
          class="linkCoupon-top_username"
          @click="gotoLogin"
      >
        {{ userStatus }}
      </div>
      <div
          v-if="couponInfo.linkIpImg"
          :style="{
          background: 'url(' + couponInfo.linkIpImg + ')',
          backgroundSize: 'cover',
        }"
          class="linkCoupon-top_header"
      ></div>
      <div class="linkCoupon-top_title">{{ couponInfo.linkIpInfo }}</div>
      <div
          v-if="!endStatus"
          :class="reciveStatus ? 'already_bg' : ''"
          class="linkCoupon-top_img"
      >
        <div class="linkCoupon-top_img-left">
          <p :class="reciveStatus ? 'already_color' : 'wait_color'">
            <span>¥</span><span>{{ couponInfo.money }}</span>
          </p>
          <p>使用期限：</p>
          <p>{{ getDateTip(couponInfo) }}</p>
        </div>
        <div
            :mg-stat-custom="'label=btn&cont=立即领券&direct=cntp&addr='"
            :mg-stat-lob="'couponid =' + id"
            class="linkCoupon-top_img-right"
            mg-stat-click
            @click="getCouponById"
        >
          {{ reciveStatus ? "已领取" : "立即领取" }}
        </div>
      </div>
      <div class="linkCoupon-top_description">
        {{ couponInfo.linkIpDescription }}
      </div>
      <div v-if="endStatus" class="linkCoupon-top_end">
        <span></span>来晚啦～活动已结束
      </div>
    </div>
    <div v-if="goodsList.length" class="linkCoupon-goods">
      <p class="linkCoupon-goods_title">活动商品</p>
      <div class="linkCoupon-goods_main">
        <div
            v-for="(item, index) in goodsList"
            :key="index"
            :class="[
            (index + 1) % 2 === 0 ? 'linkCoupon-goods_no-margin' : '',
            'linkCoupon-goods_box',
          ]"
            :mg-stat-custom="`label=goods&cont=${item.goodsId}&direct=web&addr=haowu_goods_detail`"
            :mg-stat-lob="'goodsdc =' + goodsdc"
            mg-stat-click
            @click="gotoDetail(item.goodsId)"
        >
          <div
              :mg-stat-lob="'smod=99&stype=1&goods_id=' + item.goodsId"
              class="linkCoupon-goods_img"
              mg-stat-show="flag=200"
          >
            <img v-lazy="item.originalImg"/>
          </div>
          <div class="linkCoupon-goods_desc">
            <p class="add_dot2">
              {{ item.goodsName }}
            </p>
            <p v-if="!endStatus">
              <span>券后价：</span><span>¥ </span
            ><span>{{ handleGoodsPrice(item) }}</span>
            </p>
            <p v-if="!endStatus">原价：¥{{ item.shopPrice }}</p>
            <p v-if="endStatus" class="end_goods_price">
              <span>¥ </span><span>{{ item.shopPrice }}</span>
            </p>
          </div>
        </div>
      </div>
      <div
          :mg-stat-custom="'label=btn&cont=查看更多好物&direct=cntp&addr='"
          class="linkCoupon-goods_lookMore"
          mg-stat-click
          @click="goToHome"
      >
        查看更多好物
      </div>
    </div>
  </div>
</template>

<script>
import * as couponApis from 'apis/coupon';
import { getQueryParams, guid } from 'utils/index';
import { getMgtvUserTicket, judgeLogin, setAsyncUserInfo } from 'utils/user';
import { dateFormater } from 'utils/date';

export default {
  data() {
    const { id } = getQueryParams();
    return {
      id,
      goodsList: [],
      goodsdc: this.guid(),
      userName: '',
      couponInfo: {
        linkIpImg: '',
        money: '',
        useStarTime: '',
        useEndTime: '',
        linkIpDescription: '',
        linkIpInfo: '',
      },
      reciveStatus: true,
      endStatus: false,
    };
  },
  computed: {
    userStatus() {
      if (this.endStatus) {
        return '';
      }
      return this.userName || (this.couponInfo.money ? '未登录' : '');
    },
  },
  async created() {
    const userInfo = getMgtvUserTicket();
    if (!(userInfo && userInfo.ticket)) {
      await setAsyncUserInfo();
    }
    await this.getCouponInfo();
  },
  methods: {
    guid,
    judgeLogin,
    async getCouponInfo() {
      try {
        const {
          nickname,
          couponInfo,
          couponGoods,
          reciveStatus,
        } = await couponApis.getLinkCouponInfo({ couponId: this.id });
        this.couponInfo = couponInfo;
        this.goodsList = couponGoods;
        this.reciveStatus = reciveStatus;
        this.userName = nickname;
        // 全部商品的时候显示推荐猜你喜欢
        if (this.goodsList && !this.goodsList.length) {
          this.getHotGoodsList();
        }
      } catch (error) {
        this.endStatus = true;
        this.getHotGoodsList();
      }
    },
    async getHotGoodsList() {
      // const goodsList = await goodsApis.getHotGoodsList();
      // if (Array.isArray(goodsList)) {
      //   this.goodsList = goodsList;
      // }
    },
    gotoDetail(id) {
      this.$router.push({
        path: '/goods/detail',
        query: { id, showBack: 1, goodsdc: this.goodsdc },
      });
    },
    async getCouponById() {
      if (!this.reciveStatus) {
        try {
          await couponApis.getCouponById({
            couponId: this.id,
          });
          this.reciveStatus = true;
          this.$toast('领取成功，带你遨游好物');
        } catch (error) {
          if (
            error &&
              error.message &&
              error.message.indexOf('请先登录') !== -1
          ) {
            this.judgeLogin();
          } else {
            this.$toast(error.message);
          }
        }
      }
    },
    goToHome() {
      this.$router.push({ path: '/home' });
    },
    handleGoodsPrice({ shopPrice }) {
      const price_couponed = (
        Number(shopPrice) - Number(this.couponInfo.money)
      ).toFixed(2);
      return price_couponed > 0 ? price_couponed : 0;
    },
    gotoLogin() {
      if (this.endStatus || this.userName) {
        return;
      }
      this.judgeLogin();
    },
    getDateTip({ useStartTime, useEndTime }) {
      return `${dateFormater(
        useStartTime * 1000,
        'yyyy-MM-dd',
      )} - ${dateFormater(useEndTime * 1000, 'yyyy-MM-dd')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.linkCoupon {
  height: 100%;
  background: #f6f6f6;
  overflow-y: auto;
  font-family: PingFang SC;
  -webkit-overflow-scrolling: touch;

  &-top {
    height: 560px;
    background: url("~assets/img/linkCoupon/link_bg.png") no-repeat;
    background-size: cover;
    position: relative;

    &_username {
      position: absolute;
      top: 43px;
      left: 565px;
      font-size: 28px;
      color: rgba(255, 255, 255, 1);
      width: 166px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: right;
    }

    &_header {
      position: absolute;
      top: 42px;
      left: 315px;
      height: 120px;
      width: 120px;
      background: white;
      border-radius: 50%;
    }

    &_title {
      position: absolute;
      font-size: 32px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      top: 177px;
      width: 100%;
      text-align: center;
    }

    &_img {
      position: relative;
      display: flex;
      background: url("~assets/img/linkCoupon/receive_now.png") no-repeat;
      background-size: cover;
      top: 251px;
      left: 78px;
      height: 228px;
      width: 592px;

      &-left {
        width: 362px;
        position: relative;

        p:nth-child(1) {
          position: absolute;
          width: 100%;
          top: 30px;
          text-align: center;
          font-weight: Medium;

          span:nth-child(1) {
            font-weight: bold;
            font-size: 56px;
          }

          span:nth-child(2) {
            font-weight: bold;
            font-size: 80px;
          }
        }

        p:nth-child(2) {
          position: absolute;
          bottom: 62px;
          width: 100%;
          text-align: center;
          font-size: 24px;
          color: rgba(172, 172, 172, 1);
        }

        p:nth-child(3) {
          position: absolute;
          bottom: 28px;
          width: 100%;
          text-align: center;
          font-size: 24px;
          color: rgba(172, 172, 172, 1);
        }
      }

      &-right {
        width: 230px;
        text-align: center;
        font-size: 34px;
        color: rgba(255, 255, 255, 1);
        line-height: 228px;
      }
    }

    &_description {
      position: absolute;
      top: 492px;
      width: 592px;
      left: 78px;
      font-size: 24px;
      color: rgba(255, 255, 255, 1);
    }

    &_end {
      position: absolute;
      top: 250px;
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);

      span {
        background: url("~assets/img/linkCoupon/end_icon.png") no-repeat;
        background-size: cover;
        padding: 1px 20px;
        margin-right: 6px;
      }
    }
  }

  &-goods {
    height: 100%;
    background-color: #f6f6f6;
    box-sizing: border-box;

    &_title {
      margin-top: 30px;
      margin-left: 19px;
      font-size: 32px;
      font-weight: bold;
      color: rgba(14, 14, 14, 1);
    }

    &_main {
      margin-top: 30px;
      display: flex;
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
      flex-wrap: wrap;
    }

    &_box {
      width: 350px;
      height: 555px;
      margin-right: 10px;
      margin-bottom: 14px;
      background: #fff;
      border-radius: 10px;
    }

    &_no-margin {
      margin-right: 0 !important;
    }

    &_img {
      width: 100%;
      height: 350px;
      text-align: center;

      img {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        height: 100%;
        width: 100%;
      }
    }

    &_desc {
      padding: 0 21px;

      p:nth-child(1) {
        height: 62px;
        color: #000000;
        line-height: 1.2;
        margin: 24px 0px 0px 0px;
        font-size: 28px;
      }

      p:nth-child(2) {
        line-height: 1;
        white-space: nowrap;

        span:nth-child(1) {
          font-size: 24px;
          color: #ff5f00;
        }

        span:nth-child(2) {
          font-size: 24px;
          color: #ff5f00;
          font-weight: bold;
        }

        span:nth-child(3) {
          font-weight: bold;
          font-size: 36px;
          color: #ff5f00;
        }
      }

      p:nth-child(3) {
        line-height: 1.2;
        white-space: nowrap;
        font-size: 22px;
        color: rgba(112, 112, 112, 1);
        text-decoration: line-through;
      }
    }

    &_lookMore {
      background: url("~assets/img/linkCoupon/button_bg.png") no-repeat;
      background-size: cover;
      width: 270px;
      height: 60px;
      line-height: 60px;
      margin: 83px 0px 124px 240px;
      font-size: 28px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
  }

  .already_bg {
    background: url("~assets/img/linkCoupon/already_receive.png") no-repeat;
    background-size: cover;
  }

  .already_color {
    color: #dbdbdb;
  }

  .wait_color {
    color: rgba(217, 7, 1, 1);
  }

  .noLogin {
    color: #ff893f;
    background: url("~assets/img/linkCoupon/noLogin_bg.png") no-repeat;
    background-size: contain;
    width: 114px;
    height: 38px;
    text-align: center;
    font-size: 26px;
    left: 616px;
  }

  .end_goods_price {
    span:nth-child(1) {
      font-size: 24px !important;
    }

    span:nth-child(2) {
      font-size: 36px !important;
    }
  }
}
</style>
